module.exports = __webpack_public_path__ + "img/empreendedorismo.f39752a4.png";